"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentType;
(function (PaymentType) {
    PaymentType["DEPOSIT"] = "deposit";
    PaymentType["FULL"] = "full";
    PaymentType["REMAINING"] = "remaining";
    PaymentType["REFUND"] = "refund";
    PaymentType["ADDITIONAL"] = "additional";
    PaymentType["RECONCILIATION"] = "reconciliation";
    PaymentType["MANUAL"] = "manual";
    PaymentType["DAMAGE"] = "damage";
    PaymentType["ADJUSTMENT"] = "adjustment";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
